/**
 * Admin Panel Configuration Exports
 *
 * This index file provides a clean way to import all admin panel
 * configurations and interfaces from a single location.
 */

// Export all interfaces
export * from './admin-interfaces';

// Export route configuration
export * from './admin-routes.config';
